export default __webpack_public_path__ + "static/dropdown-about-bg-c6c1150a9266e69a512989de1db4850d.png";